import React from "react";

export default function UnauthorizedPage() {
  return <div>UnauthorizedPage</div>;
}
